import "./SiteFooter.css";

const TERMLY_COOKIE_POLICY_URL =
  "https://app.termly.io/document/cookie-policy/695c0b13-af23-4639-8e65-0c8cf1351331";

function SiteFooter() {
  const handleConsentPreferencesClick = (event) => {
    if (typeof window.displayPreferenceModal === "function") {
      event.preventDefault();
      window.displayPreferenceModal();
    }
  };

  return (
    <footer className="site-footer" dir="ltr" aria-label="Legal links">
      <nav className="site-footer__links" aria-label="Website legal links">
        <a href="/legal/privacy-policy.html">Privacy Policy</a>
        <span className="site-footer__separator" aria-hidden="true">|</span>
        <a href={TERMLY_COOKIE_POLICY_URL}>Cookie Policy</a>
        <span className="site-footer__separator" aria-hidden="true">|</span>
        <a href="/legal/terms.html">Terms of Service</a>
        <span className="site-footer__separator" aria-hidden="true">|</span>
        <a
          href="/legal/privacy-policy.html#consent-preferences"
          className="termly-display-preferences"
          onClick={handleConsentPreferencesClick}
        >
          Consent Preferences
        </a>
      </nav>
    </footer>
  );
}

export default SiteFooter;
